// eslint-disable-next-line no-undef
__webpack_public_path__ = `/${Playtech.Variables.themeName}/js/app-out/`;